import { Game } from './Game';

// GOTYカテゴリ定義
export enum GotyCategory {
  OVERALL = 0,        // 総合大賞
  VISUAL = 1,         // ベストビジュアル
  SOUND = 2,          // ベストサウンド
  GAMEPLAY = 3,       // ベストゲームプレイ
  NARRATIVE = 4,      // ベストナラティブ
  ORIGINALITY = 5,    // ベストオリジナリティ
  MULTIPLAYER = 6,    // ベストマルチプレイヤー
  INDIE = 7,          // ベストインディー
  REMAKE = 8,         // ベストリメイク/リマスター
  ACCESSIBILITY = 9,  // ベストアクセシビリティ
}

export const GotyCategoryLabels: Record<GotyCategory, { en: string; ja: string }> = {
  [GotyCategory.OVERALL]: { en: 'Game of the Year', ja: 'Winner' },
  [GotyCategory.VISUAL]: { en: 'Best Visual', ja: 'ベストビジュアル' },
  [GotyCategory.SOUND]: { en: 'Best Sound', ja: 'ベストサウンド' },
  [GotyCategory.GAMEPLAY]: { en: 'Best Gameplay', ja: 'ベストゲームプレイ' },
  [GotyCategory.NARRATIVE]: { en: 'Best Narrative', ja: 'ベストナラティブ' },
  [GotyCategory.ORIGINALITY]: { en: 'Best Originality', ja: 'ベストオリジナリティ' },
  [GotyCategory.MULTIPLAYER]: { en: 'Best Multiplayer', ja: 'ベストマルチプレイヤー' },
  [GotyCategory.INDIE]: { en: 'Best Indie', ja: 'ベストインディー' },
  [GotyCategory.REMAKE]: { en: 'Best Remake/Remaster', ja: 'ベストリメイク/リマスター' },
  [GotyCategory.ACCESSIBILITY]: { en: 'Best Accessibility', ja: 'ベストアクセシビリティ' },
};

// ユーザーのGOTY選択
export interface UserGotySelection {
  id?: number;
  category: GotyCategory;
  category_name?: string;
  game: Game;
  comment: string;
  created_at?: string;
  updated_at?: string;
  created?: boolean;  // POST/PUTレスポンス用
}

// 投票ランキング
export interface GotyVoteEntry {
  game: Game;
  vote_count: number;
  rank: number;
}

export interface GotyCategoryRanking {
  category_id: GotyCategory;
  category_name: string;
  category_name_ja: string;
  games: GotyVoteEntry[];
}

export interface GotyRankings {
  year: number;
  categories: GotyCategoryRanking[];
}

// ユーザーのGOTY選択一覧（公開プロフィール用）
export interface UserGotySelectionsResponse {
  year: number;
  is_my_goty: boolean;
  user: {
    id: number;
    username: string;
    display_name: string;
    avatar: string | null;
  };
  selections: {
    category: GotyCategory;
    category_name: string;
    game: Game;
    comment: string;
    created_at: string;
  }[];
  overall_game: Game | null;  // 総合大賞のゲーム情報（Steam ID含む）
  like_count: number;
  is_liked?: boolean;
}

// 対象ゲーム一覧のレスポンス
export interface EligibleGamesResponse {
  count: number;
  results: Game[];
  page: number;
  page_size: number;
}

// ユーザーのGOTY一覧（ProfilePage用）
export interface UserGotyListItem {
  year: number;
  is_my_goty: boolean;  // True: MyGOTY（年制約なし）, False: 通常GOTY（年制約あり）
  selection_count: number;
  updated_at: string;
}

export interface UserGotyListResponse {
  gotys: UserGotyListItem[];
}
